import { useEffect, useState } from "react";
import { getActive } from "./cmd";
import { HomeTab } from "./ribbon/HomeTab";
import { InsertTab } from "./ribbon/InsertTab";
import { LayoutTab, ReviewTab } from "./ribbon/LayoutTab";
import { FONTS } from "../../lib/pages";

const TABS = ["Home", "Insert", "Layout", "Review"];

const readFmt = () => {
  const s = window.getSelection();
  const active = getActive();
  if (!s.rangeCount || !active || !active.contains(s.anchorNode)) return null;
  const el = s.anchorNode.nodeType === 3 ? s.anchorNode.parentElement : s.anchorNode;
  const cs = getComputedStyle(el);
  const fam = cs.fontFamily.split(",")[0].replace(/["']/g, "").trim().toLowerCase();
  const font = FONTS.find((f) => f.label.toLowerCase() === fam || f.value.toLowerCase().startsWith(fam))?.value || "";
  const q = (c) => { try { return document.queryCommandState(c); } catch { return false; } };
  const block = el.closest("h1,h2,h3,blockquote,p")?.tagName.toLowerCase() || "p";
  const align = cs.textAlign === "start" ? "left" : cs.textAlign;
  return {
    bold: q("bold"), italic: q("italic"), underline: q("underline"), strike: q("strikeThrough"),
    ul: q("insertUnorderedList"), ol: q("insertOrderedList"),
    size: String(Math.round(parseFloat(cs.fontSize) * 0.75 * 2) / 2), font, block, align,
  };
};

export const Ribbon = (props) => {
  const [tab, setTab] = useState("Home");
  const [fmt, setFmt] = useState({ size: "11", font: "" });
  useEffect(() => {
    let raf;
    const h = () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(() => { const f = readFmt(); if (f) setFmt(f); }); };
    document.addEventListener("selectionchange", h);
    return () => document.removeEventListener("selectionchange", h);
  }, []);
  return (
    <div className="border-b bg-card" data-testid="ribbon">
      <div className="flex items-end gap-1 px-4 pt-1" role="tablist">
        {TABS.map((t) => (
          <button key={t} type="button" role="tab" aria-selected={tab === t} onMouseDown={(e) => e.preventDefault()} onClick={() => setTab(t)}
            data-testid={`ribbon-tab-${t.toLowerCase()}`} className={`ribbon-tab ${tab === t ? "ribbon-tab-active" : ""}`}>{t}</button>
        ))}
      </div>
      <div className="ribbon-body" data-testid={`ribbon-panel-${tab.toLowerCase()}`}>
        {tab === "Home" && <HomeTab fmt={fmt} />}
        {tab === "Insert" && <InsertTab {...props} />}
        {tab === "Layout" && <LayoutTab {...props} />}
        {tab === "Review" && <ReviewTab {...props} />}
      </div>
    </div>
  );
};
